var WebChannelDataBuilder = /** @class */ (function () {
    function WebChannelDataBuilder() {
        this.webChannelData = {
            userFirstName: 'Bob',
            userLastName: 'Dodman',
            unauthenticated: false
        };
    }
    WebChannelDataBuilder.prototype.withUserFirstName = function (userFirstName) {
        this.webChannelData.userFirstName = userFirstName;
        return this;
    };
    WebChannelDataBuilder.prototype.withUserLastName = function (userLastName) {
        this.webChannelData.userLastName = userLastName;
        return this;
    };
    WebChannelDataBuilder.prototype.withUnauthenticated = function (unauthenticated) {
        this.webChannelData.unauthenticated = unauthenticated;
        return this;
    };
    WebChannelDataBuilder.prototype.build = function () {
        return this.webChannelData;
    };
    return WebChannelDataBuilder;
}());
export { WebChannelDataBuilder };
//# sourceMappingURL=web-channel-data.builder.js.map